import { ApiServiceInstance } from './Api.service';


interface RequestParams {
  token: string;
  formId: number;
  statusId: number | null;
}

interface ResponseDataType {
  status_id: number | null;
}

export const updateCustomFormStatusRequest = ({
                                                token,
                                                formId,
                                                statusId,
                                              }: RequestParams): Promise<ResponseDataType> => {

  return ApiServiceInstance.makeRequest(`/custom-form/${ formId }/update-status`, {
    method: 'PUT',
    token,
    body: {
      new_status_id: statusId,
    }
  });
};